import { render, staticRenderFns } from "./ApplicationAdd-2.vue?vue&type=template&id=399a036c&scoped=true"
import script from "./ApplicationAdd-2.vue?vue&type=script&lang=js"
export * from "./ApplicationAdd-2.vue?vue&type=script&lang=js"
import style0 from "./ApplicationAdd-2.vue?vue&type=style&index=0&id=399a036c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399a036c",
  null
  
)

export default component.exports